export const waitUnits = ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'] as const;

export const waitUnitOptions = waitUnits.map((unit) => ({ label: unit, value: unit }));
